import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var NavItemTree = function NavItemTree() {
  return import('./NavItemTree.vue');
};

export default {
  name: 'NavItemBranch',
  components: {
    NavItemTree: NavItemTree
  },
  props: {
    level: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    withColor: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  methods: {
    close: function close() {
      if (this.isOpen) {
        this.isOpen = false;
        this.$refs.tree.close();
      }
    }
  }
};